import { queryClient } from '@hotjar/webapp/utils/react-query';
import { SEGMENTS_QUERY_KEY } from '@hotjar/webapp/domains/segments/constant';
import type { Segment } from '@hotjar/webapp/features/Recordings/types';
import { fetchSegments } from './fetchSegments';
import { getSegmentById } from './getSegmentById';
import type { Store } from '../../../store/list/types';

export const applyAndNotifySegmentSaved = (store: Store, newSegment: Segment): void => {
  const { site } = store.getState();

  if (!site) {
    return;
  }

  queryClient.invalidateQueries([SEGMENTS_QUERY_KEY, { siteId: site.id }]);
  fetchSegments(site).then((segmentArray) => {
    const { setSegments, setCurrentSegment } = store.getState();

    setSegments(segmentArray);
    if (newSegment) {
      const newSegmentToSet = getSegmentById(newSegment.id, segmentArray) ?? null;
      setCurrentSegment(newSegmentToSet);

      const searchParams = new URLSearchParams(window.location.search);

      searchParams.set('segment', newSegment.id.toString());
      searchParams.delete('filters');

      window.history.pushState(
        null,
        '',
        `${window.location.pathname}?${searchParams.toString()}`.replaceAll('%3A', ':'),
      );
    }
  });
};
